export function Sms({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.25 3.375H12.75C13.7599 3.375 14.4867 3.62789 14.958 4.06543C15.4192 4.49369 15.75 5.20545 15.75 6.375V11.625C15.75 12.7946 15.4192 13.5063 14.958 13.9346C14.4867 14.3721 13.7599 14.625 12.75 14.625H5.25C4.24005 14.625 3.51326 14.3721 3.04199 13.9346C2.58079 13.5063 2.25 12.7946 2.25 11.625V6.375C2.25 5.20545 2.58079 4.49369 3.04199 4.06543C3.51326 3.62789 4.24005 3.375 5.25 3.375ZM13.7832 5.94434C13.3327 5.34971 12.4884 5.2722 11.9297 5.72168L9.58203 7.59668L9.58008 7.59766C9.45206 7.70026 9.24291 7.77539 8.99609 7.77539C8.74923 7.77536 8.54009 7.70032 8.41211 7.59766L8.41016 7.59668L6.06348 5.72168C5.48613 5.2567 4.66734 5.3811 4.22559 5.9248L4.2207 5.92969L4.2168 5.93555C3.78005 6.49458 3.86474 7.31936 4.4248 7.77441L4.42969 7.77832L6.77734 9.65332V9.65234C7.41694 10.1714 8.22592 10.4102 9 10.4102C9.77962 10.4102 10.5799 10.1682 11.2236 9.65137L13.5703 7.77832L13.5752 7.77441C14.1297 7.32388 14.2201 6.50687 13.7812 5.94531L13.7832 5.94434Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
